import { Tab, Tabs } from '@blueprintjs/core';
import * as React from 'react';

import {
  TEST_IDS,
  getProjectDiagramModelListTabTestId,
} from 'src/constants/testIds';
import { ProjectDiagramModelAttributes } from 'src/containers/ProjectDiagram/components/modelList/ProjectDiagramModelAttributes';
import { ProjectDiagramModelClasses } from 'src/containers/ProjectDiagram/components/modelList/ProjectDiagramModelClasses';
import { ProjectDiagramModelRelationships } from 'src/containers/ProjectDiagram/components/modelList/ProjectDiagramModelRelationships';
import { ModelListTab } from 'src/store/ui/types';
import { uiSlice } from 'src/store/ui/ui.slice';
import * as copy from 'src/templates/copy';
import { useReduxDispatch } from 'src/utils/hooks/useReduxDispatch';
import { useReduxSelector } from 'src/utils/hooks/useReduxSelector';

export const ProjectDiagramModelList: React.VFC = () => {
  const dispatch = useReduxDispatch();

  const tabId = useReduxSelector((state) => state.ui.modelList.tabId);

  return (
    <div className="sd-project-diagram-model-list">
      <Tabs
        animate={false}
        onChange={(tabId: string) => {
          dispatch(uiSlice.actions.selectedModelListTab(tabId as ModelListTab));
        }}
        renderActiveTabPanelOnly
        selectedTabId={tabId}
      >
        <Tab
          data-testid={getProjectDiagramModelListTabTestId(
            ModelListTab.CLASSES
          )}
          id={ModelListTab.CLASSES}
          panel={
            <div
              className="sd-project-diagram-model-list-tab-panel"
              data-testid={TEST_IDS.projectDiagram.modelList.classes.container}
            >
              <ProjectDiagramModelClasses />
            </div>
          }
          title={copy.components.projectDiagram.modelList.tabs.classes}
        />
        <Tab
          data-testid={getProjectDiagramModelListTabTestId(
            ModelListTab.RELATIONSHIPS
          )}
          id={ModelListTab.RELATIONSHIPS}
          panel={
            <div
              className="sd-project-diagram-model-list-tab-panel"
              data-testid={
                TEST_IDS.projectDiagram.modelList.relationships.container
              }
            >
              <ProjectDiagramModelRelationships />
            </div>
          }
          title={copy.components.projectDiagram.modelList.tabs.relationships}
        />
        <Tab
          data-testid={getProjectDiagramModelListTabTestId(
            ModelListTab.ATTRIBUTES
          )}
          id={ModelListTab.ATTRIBUTES}
          panel={
            <div
              className="sd-project-diagram-model-list-tab-panel"
              data-testid={
                TEST_IDS.projectDiagram.modelList.attributes.container
              }
            >
              <ProjectDiagramModelAttributes />
            </div>
          }
          title={copy.components.projectDiagram.modelList.tabs.attributes}
        />
      </Tabs>
    </div>
  );
};
